import { render, staticRenderFns } from "./Unavailability.vue?vue&type=template&id=67acc9b6"
import script from "./Unavailability.vue?vue&type=script&lang=js"
export * from "./Unavailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports